import React, { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {
  getSelectedSearchOrderType,
  getSelectedTabListView,
  getStoreLocalData,
  getUserData,
  setSelectedSearchOrderType,
  setSelectedTabListView,
} from "../utils/localStorage";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate } from "../constants/DateUtil/DateUtil";
import SchedularModal from "./SchedularModal";
import StatusFilterModal from "./StatusFilterModal";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { DataView } from "primereact/dataview";
import { brandAdminOrders } from "../services/StoreOrder/StoreOrder";
import AdminMenu from "./AdminMenu";
import useOrderDelivered from "./StoreContext/useOrderDelivered";
import { Checkbox } from "primereact/checkbox";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const { innerWidth: width, innerHeight: height } = window;

const AdminDashboardOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderFilterData, source } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  let brandId = brandProfileData.id;
  let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff ? 0 : 2;

  const {
    schedularDate,
    setSchedularDate,
    selectedStatus,
    setSelectedStatus,
    homeDeliveryValue,
    setHomeDeliveryValue,
    urgentDeliveryValue,
    setUrgentDeliveryValue,
  
    } = useOrderDelivered();

  // const resetOrdersList = () => {
  //   const ordersStore = useOrderDelivered.getState();

  //   // Reset Zustand store values
  //   ordersStore.setSchedularDate({});
  //   ordersStore.setSelectedStatus('ALL');

  //   // Reset requestData
  //   const data = {
  //     brandId: brandId,
  //     storeIds: orderFilterData.storeIds,
  //     statusIn:
  //       selectedStatus !== "ALL" ? selectedStatus : orderFilterData?.statusIn,
  //     recordType: orderFilterData?.recordType,
  //     startDate:
  //       localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
  //     endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
  //   };

  //   // Explicitly fetch first page
  //   // fetch first page explicitly
  //   fetchStoreOrders(data); // pass 0 as page
  // };

  const resetOrdersList = () => {
    const ordersStore = useOrderDelivered.getState();
    ordersStore.setSchedularDate({});
    ordersStore.setSelectedStatus('ALL');
    // no manual fetchStoreOrders call here — the useEffect below
    // will pick up the schedularDate/selectedStatus change and fetch once.
  };

  const [visible, setVisible] = useState(false);

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  // const [selectedStatus, setSelectedStatus] = useState("ALL"); // Default to show all orders
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]); // Default to show all orders
  const [recordType, setRecordType] = useState(""); // Default to show all orders
  const [loading, setLoading] = useState(false);
  const [statusTotalData, setStatusTotalData] = useState([]);
  const [sumOfGrandTotal, setSumOfGrandTotal] = useState(0);
  const [sumOfOrderCount, setSumOfOrderCount] = useState(0);

  const [tabularView, setTabularView] = useState(false);
  
    const handleTabListViewChange = async (selectedType) => {
      setTabularView(selectedType);
      await setSelectedTabListView(selectedType);
    };
  
    const fetchSelectedTabListView = async () => {
      try {
        const selectedInvoiceTypeData = await getSelectedTabListView();
        setTabularView(selectedInvoiceTypeData?.tabListView || "list");
      } catch {
        setTabularView("list");
      }
    };

  // const [schedularDate, setSchedularDate] = useState({});

  const [searchTerm, setSearchTerm] = useState("");

  const [searchFilterValue, setSearchFilterValue] = useState("");
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
  };

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
  };

  useEffect(() => {
    fetchSelectedSearchType();
    fetchSelectedTabListView();
  }, []);

  const FilterList = [
    {
      name: "By Name",
      value: "NAME",
    },
    {
      name: "By Invoice No.",
      value: "INVOICE",
    },
    {
      name: "By Mobile No.",
      value: "MOBILE",
    },
  ];
  const fetchSelectedSearchType = async () => {
    const selectedSearchTypeData = await getSelectedSearchOrderType();
    if (selectedSearchTypeData.searchOrderType !== null) {
      setSearchFilterValue(selectedSearchTypeData.searchOrderType);
    } else {
      setSearchFilterValue("");
    }
  };

  const handleSearchFilterChange = async (selectedItem) => {
    setSearchFilterValue(selectedItem);
    handleSearchType();
    await setSelectedSearchOrderType(selectedItem);
  };

  const filterOrderInfoList = () => {
    if (!searchTerm) return customerALLOrdersData; // If no search term, return all orders

    return customerALLOrdersData.filter((item) => {
      const term = searchTerm.toLowerCase();
      switch (searchFilterValue) {
        case "NAME":
          return item.customerName?.toLowerCase().includes(term);
        case "MOBILE":
          return item.customerMobile?.toLowerCase().includes(term);
        default:
          return item.invoiceNo?.toLowerCase().includes(term);
      }
    });
  };

  const filteredOrderInfoData = filterOrderInfoList();

  const handleSearchType = () => {
    setSearchTypeToggle(!searchTypeToggle);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const fetchStoreOrders = (data) => {
    setLoading(true);
    brandAdminOrders(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const statusTotals = Res.reduce((acc, order) => {
            // Check if the status already exists in the accumulator
            const existingStatus = acc.find(
              (item) => item.status === order.status
            );

            if (existingStatus) {
              // If status exists, add the current order's grandTotal to the existing sum
              existingStatus.grandTotalSum += order.grandTotal;
              existingStatus.orderCount += 1; // Increment the order count
            } else {
              // If status does not exist, create a new object with the status, grandTotal, and order count
              acc.push({
                status: order.status,
                grandTotalSum: order.grandTotal,
                orderCount: 1,
              });
            }

            return acc;
          }, []);

          const totalGrandTotalSumData = statusTotals.reduce(
            (acc, item) => acc + item.grandTotalSum,
            0
          );
          const totalOrderCountData = statusTotals.reduce(
            (acc, item) => acc + item.orderCount,
            0
          );
          setStatusTotalData(statusTotals);
          setSumOfGrandTotal(totalGrandTotalSumData);
          setSumOfOrderCount(totalOrderCountData);
          setCustomerALLOrdersData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      brandId: brandId,
      storeIds: orderFilterData.storeIds,
      statusIn:
        selectedStatus !== "ALL" ? selectedStatus : orderFilterData?.statusIn,
      recordType: orderFilterData?.recordType,
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
    };
    fetchStoreOrders(data);
  }, [source, schedularDate, selectedStatus]);

  const homeDeliveryFilter = (homeDelivery) => {
    setHomeDeliveryValue(homeDelivery);
    const data = {
      brandId: brandId,
      storeIds: orderFilterData.storeIds,
      statusIn:
        selectedStatus !== "ALL" ? selectedStatus : orderFilterData?.statusIn,
      recordType: orderFilterData?.recordType,
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
      homeDelivery: homeDelivery ? "yes" : "no",
    };
    fetchStoreOrders(data);
  };

  const urgentDeliveryFilter = (urgentDelivery) => {
    setUrgentDeliveryValue(urgentDelivery);
    const data = {
      brandId: brandId,
      storeIds: orderFilterData.storeIds,
      statusIn:
        selectedStatus !== "ALL" ? selectedStatus : orderFilterData?.statusIn,
      recordType: orderFilterData?.recordType,
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
      urgentDelivery: urgentDelivery ? "yes" : "no",
    };
    fetchStoreOrders(data);
  };

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const renderPaymentModeButtons = () => {
    return statusTotalData.map((item) => (
      <div
        key={item.status}
        style={{ backgroundColor: OrderStatusColors[item.status] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {item.orderCount} - {item.status.replace(/_/g, " ")} ({storeLocalData?.currencySymbol}{" "}
          {Number(item.grandTotalSum)?.toFixed(enabledAmountRoundOffAdmin)})
        </p>
      </div>
    ));
  };

  const itemTemplate = (order, index) => {
    const orderStatusColor =
      OrderStatusColors[order.status] || OrderStatusColors.DEFAULT;
    const displayDate =
      order.status === "DELIVERED" || order.status === "DONE"
        ? order.deliveredOn
        : order.deliveryOn;
    const displayBalanceText =
        order.status === "DELIVERED"
          ? '| Balance'
          : '';
          const displayBalanceAmount =
        order.status === "DELIVERED"
              ? '| ' + Number(order.balanceAmount)?.toFixed(enabledAmountRoundOffAdmin)
          : '';
    const displayDeliveryDateText =
      order.status === "DELIVERED" || order.status === "DONE"
        ? "Delivered On"
        : "Delivery Date";
    const formattedCreatedDate = formatDateNew(order.createdDate);
    const formattedDeliveryDate = formatDateNew(displayDate);
    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`${index + 1}`}
          >
          </AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
        <AccordionTab
          key={index}
          style={{
            "--backgroundColor-AccordionTab": orderStatusColor,
            fontSize: 10,
          }}
          header={`${
            order.invoiceNo || "N/A"
          } | ${formattedCreatedDate}  ${order.status.replace(/_/g, " ")}`}
        >
          <div
            className="cursor-pointer"
            onClick={() =>
              navigate("/OrdersGarmentInfo", {
                state: {
                  storeIdValue: order.storeId,
                  bookingOrderId: order.id,
                  storeCustomerId: order.storeCustomerId,
                  navigateThrough: 'GoBack'
                },
              })
            }
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Order No:</p>
                <p className="text-lg font-bold capitalize">
                  {order.orderNo || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Invoice No:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.invoiceNo || 0}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Order Source:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.orderSource
                    ? order.orderSource.replace(/_/g, " ")
                    : ""}
                </p>
              </div>
            </div>

            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.customerName || 0}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Mobile No.:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.customerMobile || 0}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Remarks:</p>
                <p className="text-lg font-bold capitalize">
                  {order.remarks || 0}
                </p>
              </div>
            </div>
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  {displayDeliveryDateText}:
                </p>
                <p className="text-lg font-bold capitalize">
                  {formattedDeliveryDate}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Invoice {displayBalanceText} Amount:
                </p>
                <p className="text-lg font-bold capitalize">
                  {Number(order.grandTotal)?.toFixed(enabledAmountRoundOffAdmin)} {displayBalanceAmount}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Status:</p>
                <p className="text-lg font-bold capitalize">
                  <span
                    style={{
                      color:
                        OrderStatusColors[order.status] ||
                        OrderStatusColors.DEFAULT,
                    }}
                  >
                    {order.status || "Unknown"}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex-row">
              <div className="col-8">
                <p className="text-base font-semiBold capitalize">
                  Address:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.customerAddress}
                </p>
              </div>
              {order.deliveryRemarks && (
              <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Delivery Remark:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {order.deliveryRemarks}
                  </p>
                </div>
              )}
            </div>
          </div>
        </AccordionTab>
      </Accordion>
      </div>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  const BalanceAmountTemplate = (rowData) => {
    return (
      <div className="flex flex-row justify-content-between gap-2">
        <div>
          <span className="text-md">{rowData.balanceAmount}</span>
        </div>
         
      </div>
    );
  };

  const PcsBodyTemplate = (rowData) => {
    return (
      <div className="flex flex-row justify-content-between gap-2">
        <div
          style={{ backgroundColor: "#09B4AA" }}
          className="px-2 border-round-md cursor-pointer"
          onClick={() =>
            navigate("/GarmentTags", {
              state: {
                bookingOrderId: rowData.id,
                storeCustomerId: rowData.storeCustomerId,
                orderItemId: null,
                customerALLOrdersData,
                isOrders: true,
              },
            })
          }
        >
          <span className="text-white text-lg font-bold uppercase">
            {rowData.itemGarmentCount}
          </span>
        </div>
      </div>
    );
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <div
        className="flex flex-row justify-content-between cursor-pointer"
        onClick={() =>
          navigate("/ViewInvoice", {
            state: {
              bookingOrderId: rowData.id,
              storeCustomerId: rowData.storeCustomerId,
              navigateThrough: "GoBack",
            },
          })
        }
      >
        <span style={{ color: OrderStatusColors[rowData.status] }}>
          {rowData?.status?.replace(/_/g, " ")}
        </span>
        <img
          src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
          style={{
            // height: 31,
            width: 21,
            backgroundColor: "#FFF9DE",
            borderColor: "#F5C43A",
          }}
        />
      </div>
    );
  };

  const urgentDeliveryTemplate = (rowData) => {
    return rowData?.urgentDelivery ? (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
        }
        style={{ width: "25" }}
      />
    ) : (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
        }
        style={{ width: "25" }}
      />
    );
  };

  const homeDeliveryTemplate = (rowData) => {
    return rowData?.deliveryRequest ? (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
        }
        style={{ width: "15" }}
      />
    ) : (
      <img
        src={
          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
        }
        style={{ width: "15" }}
      />
    );
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
        onClick={() =>
          
            navigate("/OrdersGarmentInfo", {
              state: {
                storeIdValue: rowData.storeId,
                bookingOrderId: rowData.id,
                storeCustomerId: rowData.storeCustomerId,
              },
            })
             
        }
      >
        <span style={{ color: "blue", textDecoration: "underline" }}>
          {rowData?.invoiceNo}
        </span>
      </div>
    );
  };

  const customerName = (rowData) => {
    return (
      <div>
        <p>
          {rowData?.customerName?.replace(/_/g, " ").substring(0, 16)}
          {rowData?.customerName?.length > 16 ? "..." : ""}
        </p>
      </div>
    );
  }

   const RenderTabView = () => {
      return (
        <DataTable
          showGridlines
          value={customerALLOrdersData}
          // header={header}
          paginator
          rows={50}
          rowsPerPageOptions={[50, 75, 100]}
          tableStyle={{ minWidth: "120rem" }}
          stripedRows
          scrollable
          scrollHeight={height - 200}
        >
          <Column
            header="S No."
            style={{ width: "80px" }}
            body={(rowData, options) =>
              options.rowIndex + 1}
          ></Column>
          <Column
            field="invoiceNo"
            header="Invoice No"
            style={{
              width: "85px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={invoiceBodyTemplate}
          ></Column>
          <Column
            field="createdDate"
            header="Booking Date"
            style={{
              width: "110px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={(rowData) => formatDateNew(rowData?.createdDate)}
          />
          <Column
            field="deliveryOn"
            header="Due Date"
            style={{
              width: "110px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={(rowData) =>
              rowData.status === "DELIVERED" || rowData.status === "DONE"
                ? formatDateNew(rowData.deliveredOn)
                : formatDateNew(rowData.deliveryOn)
            }
          ></Column>
          <Column
            field="customerName"
            header="Customer Name"
            style={{
              width: "140px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={customerName}
          ></Column>
          <Column
            field="customerMobile"
            header="Mobile"
            style={{
              width: "100px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={(rowData) => rowData?.customerMobile?.replace(/_/g, " ")}
          ></Column>
          <Column
            field="status"
            header="Status"
            style={{
              width: "170px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={statusBodyTemplate}
          ></Column>
          {/* <Column
              field="orderNo"
              header="Order No"
              body={(rowData) => rowData?.orderNo}
            /> */}
  
          <Column
            field="itemGarmentCount"
            header="Pcs"
            style={{
              width: "50px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            // body={(rowData) => rowData?.itemGarmentCount}
            body={PcsBodyTemplate}
          ></Column>
          <Column
            field="grandTotal"
            header="Amount"
            style={{
              width: "65px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
          ></Column>
          <Column
            field="balanceAmount"
            header="Balance"
            style={{
              width: "65px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={BalanceAmountTemplate}
          ></Column>
          <Column
            field="urgentDelivery"
            header="UD"
            style={{
              width: "30px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={urgentDeliveryTemplate}
          // body={(rowData) => (rowData?.urgentDelivery ? "YES" : "NO")}
          ></Column>
          <Column
            field="deliveryRequest"
            header="HD"
            style={{
              width: "30px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={homeDeliveryTemplate}
          // body={(rowData) => (rowData?.deliveryRequest ? "YES" : "NO")}
          ></Column>
          {/* <Column field="customerName" header="Customer Name"></Column>
            <Column field="customerMobile" header="Customer Mobile"></Column> */}
          {/* <Column
              field="deliveredOn"
              header="Delivered On"
              body={(rowData) => rowData.status === "DELIVERED" || rowData.status === "DONE"
                ? formatDate(rowData.deliveredOn) : ""}
            ></Column> */}
  
          <Column
            field="orderSource"
            header="Order Source"
            style={{
              width: "100px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            body={(rowData) => rowData?.orderSource?.replace(/_/g, " ")}
          ></Column>
          <Column
            field="remarks"
            header="Remarks"
            style={{ paddingVertical: 1, paddingLeft: 5, paddingRight: 1 }}
          ></Column>
          <Column
            field="deliveryRemarks"
            header="Delivery Remarks"
            style={{ paddingVertical: 1, paddingLeft: 5, paddingRight: 1 }}
          ></Column>
        </DataTable>
      );
    };

    const exportExcel = () => {
        import("xlsx").then((xlsx) => {
          const exportData = filteredOrderInfoData.map((item) => ({
            "Invoice No": item.invoiceNo,
            "Booking Date": formatDateNew(item.createdDate),
            "Due Date":
              item.status === "DELIVERED" || item.status === "DONE"
                ? formatDateNew(item.deliveredOn)
                : formatDateNew(item.deliveryOn),
            "Customer Name": item.customerName?.replace(/_/g, " "),
            Mobile: item.customerMobile,
            Status: item.status?.replace(/_/g, " "),
            Pcs: item.itemGarmentCount || 0,
            Amount: item.grandTotal || 0,
            Balance: item.balanceAmount || 0,
            UD: item.urgentDelivery ? "Yes" : "No",
            HD: item.deliveryRequest ? "Yes" : "No",
            "Order Source": item.orderSource?.replace(/_/g, " "),
            Remarks: item.remarks,
            "Delivery Remarks": item.deliveryRemarks,
          }));
    
          // 👉 Calculate totals
          const totals = exportData.reduce(
            (acc, row) => {
              acc.Pcs += row.Pcs;
              acc.Amount += row.Amount;
              acc.Balance += row.Balance;
              return acc;
            },
            { Pcs: 0, Amount: 0, Balance: 0 }
          );
    
          // 👉 Add total row
          exportData.push({
            "Invoice No": "TOTAL",
            "Booking Date": "",
            "Due Date": "",
            "Customer Name": "",
            Mobile: "",
            Status: "",
            Pcs: totals.Pcs,
            Amount: totals.Amount,
            Balance: totals.Balance,
            UD: "",
            HD: "",
            "Order Source": "",
            Remarks: "",
            "Delivery Remarks": "",
          });
    
          const worksheet = xlsx.utils.json_to_sheet(exportData);
    
          const workbook = {
            Sheets: { data: worksheet },
            SheetNames: ["data"],
          };
    
          const excelBuffer = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
    
          saveAsExcelFile(excelBuffer, 'My_' + orderFilterData.recordType);
        });
      };
    
      const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
          if (module && module.default) {
            let EXCEL_TYPE =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], {
              type: EXCEL_TYPE,
            });
    
            module.default.saveAs(
              data,
              fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
            );
          }
        });
      };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/full-dashboard")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                All Orders
              </p>
            </div>
          </div>

          {["PendingDelivery", "DeliveryOn", "Pending"].includes(
          orderFilterData.recordType
        ) && <div className="flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={exportExcel}
                src={"images/file.png"}
                style={{
                  width: 30,
                }}
              />
            </div>
          </div>}

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

          
          <div className="flex justify-content-center align-items-center cursor-pointer">
                      <div className="flex flex-1 justify-content-between my-1">
                        <p className="text-xl text-white font-medium mx-3">HD</p>
                        <Checkbox
                          checked={homeDeliveryValue}
                          size="20" // Increased size
                          color={homeDeliveryValue ? "#00A3FF" : "#C1C9D3"}
                          onClick={() => homeDeliveryFilter(!homeDeliveryValue)}
                        />
                      </div>
                    </div>
                    <div className="flex justify-content-center align-items-center cursor-pointer mr-2">
                      <div className="flex flex-1 justify-content-between my-1">
                        <p className="text-xl text-white font-medium  mx-3">UD</p>
                        <Checkbox
                          checked={urgentDeliveryValue}
                          size="20" // Increased size
                          color={urgentDeliveryValue ? "#00A3FF" : "#C1C9D3"}
                          onClick={() => urgentDeliveryFilter(!urgentDeliveryValue)}
                        />
                      </div>
                    </div>

          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => resetOrdersList()}
            className="mx-2 cursor-pointer"
          >
            <img src={"images/closeFilter.png"} style={{ width: 27 }} />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-2">
        <div
          className="flex gap-3 mb-3 pb-1 new-scroll-bar"
          style={{
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          <div
            style={{ backgroundColor: "#2B70D7" }}
            className="px-3 py-2 border-round-md"
          >
            <p className="text-white text-lg font-bold uppercase">
              {sumOfOrderCount} - All ({storeLocalData?.currencySymbol} {Number(sumOfGrandTotal).toFixed(enabledAmountRoundOffAdmin)})
            </p>
          </div>

          {renderPaymentModeButtons()}
        </div>
        <div className="my-2 mx-1 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={
                  searchFilterValue === "NAME"
                    ? "Search By Name"
                    : searchFilterValue === "MOBILE"
                    ? "Search By Mobile No."
                    : "Search By Invoice No."
                }
                value={searchTerm}
                keyboardType={
                  searchFilterValue === "NAME" ? "default" : "numeric"
                }
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm ? (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <p className="text-3xl font-bold " style={{ color: "red" }}>
                X
              </p>
            </div>
          ) : (
            <div
              onClick={handleSearchType}
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                  style={{ width: 30 }}
                />
              </div>
            </div>
          )}
        </div>
        {searchTypeToggle && (
          <div className="flex-1 mx-1 my-2">
            <Dropdown
              value={searchFilterValue}
              onChange={(e) => handleSearchFilterChange(e.value)}
              options={FilterList}
              optionLabel="name"
              placeholder="Search Filter"
              className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
            />
          </div>
        )}

        {loading ? (
                  <div style={{ flex: 1 }}>
                    <div className="text-center">
                      <ProgressSpinner
                        style={{ width: "70px", height: "70px" }}
                        strokeWidth="4"
                        fill="var(--surface-ground)"
                        animationDuration="2s"
                      />
                    </div>
                  </div>
                ) : customerALLOrdersData?.length > 0 ? (
                  <div>
                    <div>
                      {tabularView === "tab" && (
                        <div
                          className="scroll-bar mb-2"
                        >
                          <div className="report-table">
                            <div className="tab-view-table">{RenderTabView()}</div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div style={{ display: tabularView === "tab" ? "none" : "" }}>
                      <DataView
                        value={filteredOrderInfoData || customerALLOrdersData}
                        listTemplate={listTemplate}
                        paginator
                        rows={20}
                  style={{ maxHeight: height - 180, overflowY: 'auto' }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-content-center align-items-center">
                    <p className="text-xl font-semi-bold">No Order Found</p>
                  </div>
                )}

        
      </div>
      <SchedularModal
        setSchedularModalVisible={setSchedularModalVisible}
        schedularModalVisible={schedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        typeOfOrder={orderFilterData?.recordType}
      />
      <StatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={orderFilterData?.statusIn}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default AdminDashboardOrder;
